import { Client } from "@/Common/Api/Client";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { AbstractDirectoryPreFaxCallback } from "./AbstractDirectoryPreFaxCallback";
import { DirectoryEntityPatientLink } from "./DirectoryPatientLinkUpdate";
import { DirectoryPharmacy } from "./DirectoryPharmacy";

export class DirectoryPreferredPharmacyUpdate extends AbstractDirectoryPreFaxCallback<DirectoryEntityPatientLink> {
    public async trigger(): Promise<void> {
        const model = this.model;
        if (
            (!model?.directoryEntity && !model?.customPharmacy)
            || !model?.patientContactId
            || model?.entityType !== DirectoryEntityType.Pharmacy
        )
            return;

        const directoryPharmacy = model.directoryEntity as DirectoryPharmacy;
        const pharmacy = model.customPharmacy ?? directoryPharmacy?.getPharmacyInfo(false);

        const request = {
            PatientContactId: model.patientContactId,
            PharmacyName: pharmacy.Name,
            PharmacyBanner: pharmacy.Banner,
            PharmacyPhone: pharmacy.Phone,
            PharmacyFax: pharmacy.Fax,
            PharmacyAddress: pharmacy.Address,
            DirectoryPharmacyId: directoryPharmacy?.id
        };

        const response = await Client.postAsync(ServerOperations.Server.Myle_UpdatePreferredPharmacy, request);

        if (response.isSuccess)
            sessionStore.dispatch(LocalPatientOperations.Fax.UpdatePreferredPharmacy, { pharmacy, directoryPharmacy });
        else
            sessionStore.showPopup(response.errors);
    }
}
